import { useSelector } from 'react-redux';
import { TStore } from '../basis/types/tstore';

import { isDevelopment } from '../utils/env';

// 获取当前用户ID
export const usePersonUserId = () => {
  const userId = useSelector((state: TStore.State) => state.person.user?.userId);

  return { currentUserId: isDevelopment ? (userId ?? '' ?? '38531') : (userId ?? '') };
};
